import React from "react";
import {
  FaBuilding,
  FaCalendarAlt,
  FaLayerGroup,
  FaSignal,
  FaUsers,
} from "react-icons/fa";

function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

function StatusBadge({ activity }) {
  const styles = {
    emerald:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300",
    amber:
      "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
    rose: "bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300",
    slate:
      "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold",
        styles[activity?.tone] || styles.slate
      )}
    >
      {activity?.label || "Inconnu"}
    </span>
  );
}

function InfoPill({ icon: Icon, children, tone = "slate" }) {
  const tones = {
    slate:
      "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200",
    blue: "bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300",
    violet:
      "bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300",
    amber:
      "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
  };

  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium ${tones[tone] || tones.slate}`}
    >
      <Icon className="h-3.5 w-3.5" />
      {children}
    </span>
  );
}

const AttendanceClubCard = ({
  club,
  lastCallFormatted = "—",
  compact = false,
}) => {
  return (
    <div className="rounded-[28px] border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-sm overflow-hidden">
      <div className="p-5 md:p-6">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <h3 className="text-lg font-bold text-slate-900 dark:text-white">
                {club?.nom_club || "Club sans nom"}
              </h3>
              <StatusBadge activity={club?.activity} />
            </div>

            <div className="mt-3 space-y-2 text-sm text-slate-500 dark:text-slate-400">
              <div className="flex items-center gap-2">
                <FaCalendarAlt className="shrink-0" />
                <span>
                  Dernier appel :{" "}
                  <span className="font-medium text-slate-700 dark:text-slate-200">
                    {lastCallFormatted !== "—" ? lastCallFormatted : club?.activity?.lastCallLabel}
                  </span>
                </span>
              </div>

              <div className="flex items-center gap-2">
                <FaSignal className="shrink-0" />
                <span>
                  Activité :{" "}
                  <span className="font-medium text-slate-700 dark:text-slate-200">
                    {club?.activity?.lastCallLabel || "—"}
                  </span>
                </span>
              </div>
            </div>
          </div>

          {!compact ? (
            <div className="rounded-2xl px-4 py-3 bg-slate-50 dark:bg-slate-950/40 border border-slate-200 dark:border-slate-800 min-w-[140px]">
              <div className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-400 font-semibold">
                Appels totaux
              </div>
              <div className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">
                {club?.totalCalls || 0}
              </div>
            </div>
          ) : null}
        </div>

        <div className="mt-4 flex flex-wrap gap-2">
          <InfoPill icon={FaBuilding} tone="blue">
            Club
          </InfoPill>
          <InfoPill icon={FaLayerGroup} tone="violet">
            {club?.groupsCount || 0} groupe{club?.groupsCount > 1 ? "s" : ""}
          </InfoPill>
          <InfoPill icon={FaUsers} tone="amber">
            {club?.totalCalls || 0} appel{club?.totalCalls > 1 ? "s" : ""}
          </InfoPill>
          <InfoPill icon={FaSignal} tone="slate">
            {club?.avgCallsPerGroup || 0} / groupe
          </InfoPill>
        </div>
      </div>
    </div>
  );
};

export default AttendanceClubCard;